import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export default {
    auth: [...authRoles.admin],
    routes: [{ exact: true, path: '/pail-weights', component: FuseLoadable({ loader: () => import('./PailWeightApp') }) }],
};
